import { useContext, useEffect } from 'react';

import {
  Typography,
  useTheme,
  useMediaQuery,
  makeStyles,
} from '@material-ui/core';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';

import CardList from './CardList';
import SliderCards from './SliderCards';
import { Container, Social, Content, Presentation } from './styles';
import { AppContext } from '../../contexts/AppContext';
import CustomHr from '../CustomHr';
import SocialLinks from '../SocialLinks';

const useStyles = makeStyles(theme => ({
  text: {
    [theme.breakpoints.down('md')]: {
      textAlign: 'left',
      position: 'relative',
      width: '240px',
      top: '8rem',
      left: '-45px',
    },
  },
}));

function TopPresentation({
  images,
  title,
  subTitle,
  invertTitle,
  iconButton,
  miniTitle,
}) {
  const context = useContext(AppContext);
  const { isUpMd } = context;
  const classes = useStyles();
  const theme = useTheme();
  const isUpLg = useMediaQuery(theme.breakpoints.up('lg'));
  const history = useHistory();
  const isWhoWeArePage = useRouteMatch('/quem-somos');
  const location = useLocation();

  useEffect(() => {
    if (isWhoWeArePage && isWhoWeArePage.isExact) {
      const hash = location.hash.split('#')[1];
      scroller.scrollTo(hash, {
        smooth: true,
        offset: -50,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function HandleLink(hash) {
    if (!isWhoWeArePage) history.push(`quem-somos/#${hash}`);

    if (isWhoWeArePage && isWhoWeArePage.isExact) {
      scroller.scrollTo(hash, { smooth: true, offset: -50 });
    }
  }

  return (
    <Container background={images}>
      <Social>
        <SocialLinks />
      </Social>
      <Content>
        <Presentation inverttitle={invertTitle}>
          {isUpLg && (
            <Typography
              color={isUpLg ? 'textPrimary' : 'textSecondary'}
              variant="h3"
              className={classes.text}
            >
              {title}
            </Typography>
          )}
          {isUpLg && (
            <>
              <CustomHr forceLeftOnMobile />
              <Typography
                color={isUpLg ? 'textPrimary' : 'textSecondary'}
                variant="h1"
                className={classes.text}
              >
                {subTitle}
              </Typography>
              <Typography
                color={isUpLg ? 'textPrimary' : 'textSecondary'}
                variant="h3"
                style={{ paddingTop: '12px' }}
                className={classes.text}
              >
                {miniTitle}
              </Typography>
            </>
          )}
        </Presentation>
      </Content>
      {isUpMd ? (
        <CardList iconButton={iconButton} click={HandleLink} />
      ) : (
        <SliderCards click={HandleLink} />
      )}
    </Container>
  );
}

export default TopPresentation;
